import { localize, localeChanged } from 'vee-validate'

const vuetify = ['zhHans', 'zhHant']
const vee = ['zh_CN', 'zh_TW']
const bcp47 = ['zh-cn', 'zh-hk']

// Function For Dynamic Imports of Language Dictionary
function lazyLoadLocale (locale, i18n) {
  // If the locale hasn't been loaded yet
  if ((i18n.locale !== locale && !window.loadedLocales.includes(locale)) || window.loadedLocales.length === 0) {
    return import(/* webpackChunkName: "locale-[request]" */ '@/assets/locales/' + locale + '.js').then(
      messages => {
        i18n.setLocaleMessage(locale, messages.default)
        window.loadedLocales.push(locale)
        return import(/* webpackChunkName: "vee-[request]" */ 'vee-validate/dist/locale/' + convertLocale(locale, 'vee') + '.json').then(
          imports => {
            localize(convertLocale(locale, 'vee'), imports)
            return true
          })
      }
    )
  }
  return new Promise((resolve) => resolve(false))
}

// Convert locale identifier to specified format
function convertLocale (locale, to) {
  to = selectLocalePack(to)

  if (to !== null) {
    let result = null

    result = matchLocale(locale, vuetify, to)
    if (result) return result

    result = matchLocale(locale, vee, to)
    if (result) return result

    result = matchLocale(locale, bcp47, to)
    if (result) return result
  }

  return locale
}

// Selects the locale pack (defined const) to use
function selectLocalePack (to) {
  if (to === 'vuetify') return vuetify
  if (to === 'vee') return vee
  if (to === 'bcp47') return bcp47
  return null
}

// Match / Maps / Translate locale identifier
function matchLocale (locale, from, to) {
  for (let i = 0; i < from.length; i++) {
    if (from[i] === locale) {
      return to[i]
    }
  }
  return null
}

export default {
  methods: {
    // Initialize Locale At The Start Of App
    initLocale () {
      return lazyLoadLocale(this.$root.$i18n.locale, this.$root.$i18n)
    },
    // Function to Change Locale
    // locale: (String) Locale Identifier
    // referesh: (Boolean) Force Refresh Of Page [Default: False]
    changeLocale (locale, refresh = false) {
      locale = convertLocale(locale, 'vuetify')
      if (this.currentLocale !== locale) {
        lazyLoadLocale(locale, this.$root.$i18n).then(() => {
          this.$root.$i18n.locale = locale
          this.$vuetify.lang.current = locale
          document.cookie = 'locale=' + locale
          localeChanged()

          if (refresh) {
            this.$router.go()
          } else {
            this.$root.$emit('localeChanged', locale)
          }
        })
      }
    },
    // Function to Convert Locale Format (eg. between zhHant & zh_HK)
    // locale: (String) Locale Identifier
    // to: (String) destination locale format ['vuetify', 'vee', 'bcp47']
    convertLocale (locale, to) {
      return convertLocale(locale, to)
    }
  },
  computed: {
    // Get Available Locales In This Application (Installed / Initialized)
    availableLocales () {
      return this.$i18n.availableLocales
    },
    // Get Current Locale
    currentLocale () {
      return this.$root.$i18n.locale
    }
  }
}
